import React from 'react';
import { useAppSelector } from '../../../../utilities/hooks';
import { FieldProject } from '@sitemax/smx-components';

interface FieldProjectForAddItemProps {
    refListProject: React.RefObject<React.FC<any>>;
}

const FieldProjectForAddItem: React.FC<FieldProjectForAddItemProps> = ({ refListProject }) => {
    const globalFilterProject = useAppSelector((state) => state.app.globalFilterProject);
    const globalFilterStatus = useAppSelector((state) => state.app.globalFilterStatus);
    const dataSettingFromServer = useAppSelector((state) => state.app.dataSettingFromServer);
    const user = useAppSelector((state) => state.account.user);

    const [textSettingGant] = dataSettingFromServer.rows.filter((set) => set.name === 'gant');

    const settingGant = JSON.parse(textSettingGant?.data || '{}');

    const disabledListProject = settingGant.gantEditScheduleItem
        ?.map((settingEditScheduleItem: { projectId: string; userId: string }) => {
            const isOtherAuthorEdit = user && settingEditScheduleItem.userId !== user?.id;

            if (isOtherAuthorEdit) {
                return settingEditScheduleItem.projectId;
            }
            return null;
        })
        .filter((id: string) => id);

    // const localFilters = {} as any;
    //
    // if (globalFilterProject?.length) {
    //     localFilters.id = globalFilterProject;
    // }
    //
    // if (globalFilterStatus) {
    //     localFilters.status = globalFilterStatus;
    // }

    const filterFlexibleProject = globalFilterProject?.length
        ? `{"or":[{"id":"${globalFilterProject.join('|')}"}]}`
        : '';
    const filterFlexibleStatus = globalFilterStatus ? `{"status":"${globalFilterStatus}"}` : '';

    const arrayExistFilter = [filterFlexibleProject, filterFlexibleStatus].filter(Boolean);

    const filterFlexible = arrayExistFilter.length ? `[${arrayExistFilter.join(',')}]` : undefined;

    return (
        <FieldProject
            name={'projectId'}
            ref={refListProject as any}
            required
            // localFilters={Object.keys(localFilters).length ? localFilters : undefined}
            filterFlexible={filterFlexible}
            disabledListProject={disabledListProject}
        />
    );
};

export default FieldProjectForAddItem;
